function shouldReduceMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function isCoarsePointer() {
  return window.matchMedia('(pointer: coarse)').matches;
}

function applyHeroTitleWithAccent(title, fullText) {
  const normalized = fullText.replace(/\s[\u2014—-]\s/g, " ");
  const marker = " with you ";
  const i = normalized.indexOf(marker);
  if (i !== -1) {
    const a = normalized.slice(0, i + marker.length).trimEnd();
    const b = normalized.slice(i + marker.length).trim();
    title.innerHTML = `${a}<br class="hero-title-break" aria-hidden="true" /><span class="hero-title-tagline">${b}</span>`;
    return;
  }
  title.textContent = normalized;
}

function initHeroTyping() {
  const title = document.querySelector('[data-typing]');
  if (!title) return;

  const fullText = title.getAttribute('data-typing') || title.textContent || '';
  if (!fullText) return;

  if (shouldReduceMotion()) {
    applyHeroTitleWithAccent(title, fullText);
    return;
  }

  title.textContent = '';
  let index = 0;
  const tickMs = 24;

  const step = () => {
    index += 1;
    if (index >= fullText.length) {
      applyHeroTitleWithAccent(title, fullText);
      return;
    }
    title.textContent = fullText.slice(0, index);
    window.setTimeout(step, tickMs);
  };

  window.setTimeout(step, 180);
}

function initCardSpotlight() {
  if (shouldReduceMotion() || isCoarsePointer()) return;

  const targets = Array.from(
    document.querySelectorAll('.card, .project-card, .stat-card, .step, .glass-card')
  );
  if (!targets.length) return;

  for (const el of targets) {
    el.style.setProperty('--spotlight-x', '50%');
    el.style.setProperty('--spotlight-y', '50%');

    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--spotlight-x', `${x.toFixed(1)}%`);
      el.style.setProperty('--spotlight-y', `${y.toFixed(1)}%`);
    });
  }
}

function initInteractiveTilt() {
  if (shouldReduceMotion() || isCoarsePointer()) return;

  const targets = Array.from(
    document.querySelectorAll('.card, .project-card, .stat-card, .step, .glass-card')
  );
  if (!targets.length) return;

  const MAX_ROTATE = 5;

  const reset = (el) => {
    el.style.transform = '';
  };

  for (const el of targets) {
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      const rotateY = (x - 0.5) * MAX_ROTATE * 2;
      const rotateX = (0.5 - y) * MAX_ROTATE * 2;
      el.style.transform = `perspective(900px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) translateY(-4px)`;
    });

    el.addEventListener('mouseleave', () => reset(el));
    el.addEventListener('blur', () => reset(el));
  }
}

function initPointerParallax() {
  if (shouldReduceMotion()) return;
  const hero = document.querySelector('.hero');
  if (!hero) return;

  const blob1 = hero.querySelector('.blob-1');
  const blob2 = hero.querySelector('.blob-2');
  if (!blob1 || !blob2) return;

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    const nx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    const ny = ((e.clientY - rect.top) / rect.height - 0.5) * 2;

    blob1.style.transform = `translate3d(${(nx * 14).toFixed(2)}px, ${(ny * 10).toFixed(2)}px, 0)`;
    blob2.style.transform = `translate3d(${(nx * -16).toFixed(2)}px, ${(ny * -12).toFixed(2)}px, 0)`;
  });

  hero.addEventListener('mouseleave', () => {
    blob1.style.transform = '';
    blob2.style.transform = '';
  });
}

export function initMotionEffects() {
  initHeroTyping();
  initCardSpotlight();
  initInteractiveTilt();
  initPointerParallax();
}
